export enum TaxationType {
  OnPayment = 'on_payment',
  OnCreation = 'on_creation',
}
